import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivityGroup, ActivityGroupPerson } from '../../../interfaces/activity.interface';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { AvatarTypePipe } from '../../../pipes/avatar-type.pipe';
import { OnGetData } from '../../../services/dialog.service';
import { LinkListItemComponent } from '../../../shared-extra/components/link-list-item/link-list-item.component';
import { AvatarPipe } from '../../../shared-extra/pipes/avatar.pipe';
import { InViewDirective } from '../../../shared/directives/in-view.directive';
import { ScrollElementDirective } from '../../../shared/directives/scroll-element.directive';

@Component({
  selector: 'app-activity-people-dialog',
  templateUrl: './activity-people-dialog.component.html',
  styleUrls: ['./activity-people-dialog.component.scss'],
  standalone: true,
  imports: [ScrollElementDirective, InViewDirective, LinkListItemComponent, AsyncPipe, AvatarPipe, AvatarTypePipe],
})
export class ActivityPeopleDialogComponent implements OnGetData {
  dialogName = 'activity-people';
  group: ActivityGroup;
  word: string;
  people: ActivityGroupPerson[];

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  async onGetData(data: { people: ActivityGroupPerson[] }) {
    this.people = data.people;
  }

  trackFn(index: number, item: ActivityGroupPerson) {
    return item.id;
  }
}
